export const EDIT_PAGE_MAIN_CONTENT_ID = 'edit-page-main-content';

export const WIDGET_PREFIX = 'assignment-widget-';

export const ARTICLE_TYPE = 1
export const FOLDER_TYPE  = 2

export const FIELD_DATA_TYPES = {
    STRING: 1,
    ASSETS: 2,
    FEATURED_IMAGE: 3,
    MULTIPLE_CHOICES: 4,
    SINGLE_CHOICE: 5,
    SINGLE_IMAGE: 6,
};

export const COMMENT_WIDGET_TYPES = {
    SIMPLE: 1,
    ASSETS: 2,
    WYSIWYG: 3,
    SINGLE_IMAGE: 4
};

export const TITLE_WIDGET_ID            = 1
export const CONTENT_WIDGET_ID          = 2
export const FILES_WIDGET_ID            = 3
export const FEATURED_IMAGE_WIDGET_ID   = 4
export const EXCERPT_WIDGET_ID          = 5
export const TAGS_WIDGET_ID             = 6
export const CUSTOM_POST_SLUG_WIDGET_ID = 7
export const META_TITLE_WIDGET_ID       = 8
export const META_DESCRIPTION_WIDGET_ID = 9
